// extracted by mini-css-extract-plugin
export default {"button":"Client_button__L4kkU","icon":"Client_icon__DUXEA","path":"Client_path__KxYvZ","isTiny":"Client_isTiny__dqLnt"};